import { render, staticRenderFns } from "./exercise.vue?vue&type=template&id=4ae00dfc&"
import script from "./exercise.vue?vue&type=script&lang=js&"
export * from "./exercise.vue?vue&type=script&lang=js&"
import style0 from "./exercise.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports